var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "read-more js-read-more" }, [
    _c("div", [
      _vm._v("\n    " + _vm._s(_vm.firstChars) + "\n    "),
      _vm.isFeatureEnable
        ? _c("span", { attrs: { "data-toggle": "" } }, [
            _c("a", [_vm._v(_vm._s(_vm.seeMore))])
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", [
      _vm._v("\n    " + _vm._s(_vm.lastChars) + "\n    "),
      _c("span", { attrs: { "data-toggle": "" } }, [
        _c("a", [_vm._v(_vm._s(_vm.seeLess))])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }